export default __webpack_public_path__ + "static/media/pink beret.9fc0a644.png";